module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style2/testimonial-style2.component.scss
// module id = ./src/app/features/testimonial/testimonial-style2/testimonial-style2.component.scss
// module chunks = main